import { useNavigate, useLocation, Navigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { addDoc, collection, query, where, deleteDoc, onSnapshot, doc, setDoc, updateDoc, getDocs, limit, orderBy } from "firebase/firestore";
import { db } from "../firebase.js";
import Lodinging from "../components_root/loading.jsx";
import Lodingingimg from "../components_root/loadingimg.jsx";
import Cookies from "js-cookie";
import './products-list.css';
import { Toast } from '../components_root/ToastContext.jsx';

import { MdAdd, MdAddAPhoto, MdVisibility, MdOutlineShoppingCartCheckout, MdArrowBackIos, MdDeleteOutline, MdStarBorder, MdDeleteForever, MdArrowOutward, MdArrowCircleRight, MdArrowRight, MdInfoOutline } from "react-icons/md";

import logo_default from "../assets/logo_default.jpg";
import banner_default from "../assets/banner_default.jpg";
import { Save_products_edit } from "./save_products_edit.js";
import { Product_uploader_files } from "./product_uploader_files.js";
import { deleteFileByUid } from "../components_root/deleteFileByUid.js";
import { Product_price_edit } from "./product_price_edit.js";
import Select_yes_no from "../components_root/select_yes_no.jsx";
import { Product_services_edit } from "./product_services_edit.js";
import { Product_item_details_edit } from "./product_item_details_edit.js";
import { Product_details_edit } from "./product_details_edit.js";
import { Set_thumbnail } from "./set_thumbnail.js";
import { Product_sales_details_edit } from "./product_sales_details_edit.js";
export const seo = {
    title: "aooz Services | Free & Premium Online Tools for Productivity, SEO & File Conversion",
    description: "Discover aooz's free and premium online services including word counter, image to PDF, favicon generator, SEO analyzers, text utilities, and more. Enhance productivity with powerful tools for students, writers, developers, and businesses.",
    keywords: "aooz services, free online tools, premium tools, seo tools, text utilities, file converters, image to pdf, favicon generator, word counter, productivity tools, online converters",
    url: "https://aooz.in/services",
    image: "https://aooz.in/assets/logo.png"
};
export default function Products_Edit() {
    const [text, setText] = useState("");
    const location = useLocation();
    const { Toastshow } = Toast();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [isLoading2, setIsLoading2] = useState(true);
    const [isLoading3, setIsLoading3] = useState(true);
    const [collapsed, setCollapsed] = useState(false);
    const [activeTab, setActiveTab] = useState("product");
    const [categoryData, setCategoryData] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState("All");
    const [selectedSubcategory, setSelectedSubcategory] = useState("");
    const [color, setColor] = useState("#000000");
    const [colorname, setColorname] = useState("");
    const [brandname, setBrandname] = useState("");
    const [packingitem, setPackingitem] = useState("");
    const [agreeDelete, setAgreeDelete] = useState(false);
    //
    const [productsdata, setProductsdata] = useState([]);

    const [uid, setUid] = useState("");
    const [viewfile_url, setViewfile_url] = useState("");

    const [price, setPrice] = useState("");
    const [mrp, setMrp] = useState("");
    const [discount, setDiscount] = useState("");
    const [benefit, setBenefit] = useState("");
    const [dealname, setDealname] = useState("");
    //services
    const [deliverycharges, setDeliverycharges] = useState("");
    const [deliverydays, setDeliverydays] = useState("");
    const [warranty, setWarranty] = useState("");
    const [warrantystatus, setWarrantystatus] = useState(true);
    const [notreturnablestatus, setNotreturnablestatus] = useState(false);
    const [cashpayon, setCashpayon] = useState(true);
    const [companyuid, setCompanyuid] = useState("");
    //
    useEffect(() => {
        const companyuid = Cookies.get("select_company_uid");
        if (companyuid) {
            setCompanyuid(companyuid);
        } else {
            navigate("/dashboard?menu=companieslist");
        }
    }, []);
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const uId = params.get("uid");
        setUid(uId);
    }, [location]);
    //
    const [modelname, setModelname] = useState("");
    const [usecase, setUsecase] = useState("");
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [keywords, setKeywords] = useState("");
    const [product_filedata, setProduct_filedata] = useState([]);

    const Save_productsedit = async () => {
        if (!brandname) return Toastshow("Please enter brand name");
        if (!modelname) return Toastshow("Please enter modelname");
        if (!usecase) return Toastshow("Please enter usecase");
        if (!title) return Toastshow("Please enter title");
        if (!description) return Toastshow("Please enter description");
        if (!keywords) return Toastshow("Please enter keywords");
        if (!uid) return Toastshow("Please enter uid ");
        try {
            const result = await Save_products_edit({
                uid,
                brandname: brandname.trim().toLocaleLowerCase(),
                modelname: modelname.trim().toLocaleLowerCase(),
                usecase: usecase.trim().toLocaleLowerCase(),
                title,
                description,
                keywords,
            });
            if (result.success) {
                Toastshow("Saved successfully!");
            } else {
                Toastshow("Error: " + (result.error || "Unknown error"));
            }
        } catch (error) {
            console.error("❌ Error submitting post:", error);
            Toastshow("Error submitting post: " + error.message);
        }
    };
    const Save_Product_price_edit = async () => {

        if (!price) return Toastshow("Please enter price");

        if (!uid) return Toastshow("Please enter uid ");
        try {
            const result = await Product_price_edit({
                uid,
                price,
                mrp,
                discount,
                benefit,
                dealname
            });
            if (result.success) {
                Toastshow("Saved successfully!");
            } else {
                Toastshow("Error: " + (result.error || "Unknown error"));
            }
        } catch (error) {
            console.error("❌ Error submitting post:", error);
            Toastshow("Error submitting post: " + error.message);
        }
    };
    const Save_Product_services_edit = async () => {


        if (!uid) return Toastshow("Please enter uid ");
        try {
            const result = await Product_services_edit({
                uid,
                deliverycharges,
                deliverydays,
                warranty,
                warrantystatus,
                notreturnablestatus,
                cashpayon

            });
            if (result.success) {
                Toastshow("Saved successfully!");
            } else {
                Toastshow("Error: " + (result.error || "Unknown error"));
            }
        } catch (error) {
            console.error("❌ Error submitting post:", error);
            Toastshow("Error submitting post: " + error.message);
        }
    };
    const Save_Product_item_details_edit = async () => {


        if (!uid) return Toastshow("Please enter uid ");
        try {
            const result = await Product_item_details_edit({
                uid,
                color,
                colorname,
                packingitem,

            });
            if (result.success) {
                Toastshow("Saved successfully!");
            } else {
                Toastshow("Error: " + (result.error || "Unknown error"));
            }
        } catch (error) {
            console.error("❌ Error submitting post:", error);
            Toastshow("Error submitting post: " + error.message);
        }
    };

    //Set_thumbnail
    const Save_Set_thumbnail = async (thumbnail) => {


        if (!uid) return Toastshow("Please enter uid ");
        try {
            const result = await Set_thumbnail({
                uid,
                thumbnail

            });
            if (result.success) {
                Toastshow("Set thumbnail successfully!");
            } else {
                Toastshow("Error: " + (result.error || "Unknown error"));
            }
        } catch (error) {
            console.error("❌ Error submitting post:", error);
            Toastshow("Error submitting post: " + error.message);
        }
    };

    //Save_Product__technical_details_edit
    const [technical, setTechnical] = useState("");
    const [technicalvalue, setTechnicalvalue] = useState("");
    const Save_Product__technical_details_edit = async () => {
        if (!technical) return Toastshow("Please Title");
        if (!technicalvalue) return Toastshow("Please Value");
        if (!uid) return Toastshow("Please enter uid ");
        if (!detailstitle) return Toastshow("Please enter details ");
        try {
            const result = await Product_details_edit({
                uid,
                details: detailstitle,
                category: "technical",
                [technical.replaceAll(" ", "_").toLocaleLowerCase()]: technicalvalue
            });
            if (result.success) {
                Toastshow("Saved successfully!");
                setTechnical("");
                setTechnicalvalue("");
                fetchtechnicalFields();
            } else {
                Toastshow("Error: " + (result.error || "Unknown error"));
            }
        } catch (error) {
            console.error("❌ Error submitting post:", error);
            Toastshow("Error submitting post: " + error.message);
        }
    };
    //technicaldata
    const [technicaldata, setTechnicaldata] = useState([]);
    const fetchtechnicalFields = async () => {
        try {
            setIsLoading3(true);
            // 1️⃣ Get the product document
            const productSnap = await getDocs(
                query(collection(db, "products"), where("uid", "==", uid))
            );
            if (productSnap.empty) {
                setTechnicaldata([]);
                setIsLoading3(false);
                return;
            }
            const products = await Promise.all(
                productSnap.docs.map(async (docSnap) => {
                    const docData = docSnap.data();
                    const fieldsSnap = await getDocs(
                        query(
                            collection(docSnap.ref, "fields"),
                            where("category", "==", "technical")
                        )
                    );
                    // 3️⃣ Map fields to array
                    const child = fieldsSnap.docs.map((fieldDoc) => ({
                        id: fieldDoc.id,      // Firestore doc ID
                        ...fieldDoc.data()    // All your saved fields (uid, fieldName, fieldValue, etc.)
                    }));

                    return { uid: docSnap.id, ...docData, child };
                })
            );
            setTechnicaldata(products);
        } catch (err) {
            console.error("Error fetching technical fields:", err);
        } finally {
            setIsLoading3(false);
        }
    };
    useEffect(() => {
        fetchtechnicalFields();
    }, []);
    //Product_additional_details_edit
    const [additional, setAdditional] = useState("");
    const [additionalvalue, setAdditionalvalue] = useState("");
    const [detailstitle, setDetailstitle] = useState("");
    const Save_Product_additional_details_edit = async () => {
        if (!additional) return Toastshow("Please Title");
        if (!additionalvalue) return Toastshow("Please Value");
        if (!uid) return Toastshow("Please enter uid ");
        if (!detailstitle) return Toastshow("Please enter details ");
        try {
            const result = await Product_details_edit({
                uid,
                details: detailstitle,
                category: "additional",
                [additional.replaceAll(" ", "_").toLocaleLowerCase()]: additionalvalue

            });
            if (result.success) {
                Toastshow("Saved successfully!");
                setAdditional("");
                setAdditionalvalue("");
                fetchAdditionalFields();
            } else {
                Toastshow("Error: " + (result.error || "Unknown error"));
            }
        } catch (error) {
            console.error("❌ Error submitting post:", error);
            Toastshow("Error submitting post: " + error.message);
        }
    };

    //additionaldata
    const [additionaldata, setAdditionaldata] = useState([]);
    const fetchAdditionalFields = async () => {
        try {
            setIsLoading3(true);

            // 1️⃣ Get the product document
            const productSnap = await getDocs(
                query(collection(db, "products"), where("uid", "==", uid))
            );

            if (productSnap.empty) {
                setAdditionaldata([]);
                setIsLoading3(false);
                return;
            }

            const products = await Promise.all(
                productSnap.docs.map(async (docSnap) => {
                    const docData = docSnap.data();

                    // 2️⃣ Get fields where category == "technical"
                    const fieldsSnap = await getDocs(
                        query(
                            collection(docSnap.ref, "fields"),
                            where("category", "==", "additional")
                        )
                    );

                    const child = fieldsSnap.docs.map((fieldDoc) => ({
                        id: fieldDoc.id,
                        ...fieldDoc.data()
                    }));

                    return { uid: docSnap.id, ...docData, child };
                })

            );

            setAdditionaldata(products);
        } catch (err) {
            console.error("Error fetching technical fields:", err);
        } finally {
            setIsLoading3(false);
        }
    };
    useEffect(() => {
        fetchAdditionalFields();
    }, [uid]);
    //Save_Product__technical_details_edit
    const [salesurl, setSalesurl] = useState("");
    const [saleprice, setSaleprice] = useState("");
    const [salesname, setSalesname] = useState("");
    const Save_product_sales_details_edit = async () => {
        if (!salesname) return Toastshow("Please Title");
        if (!salesurl) return Toastshow("Please URL");
        if (!saleprice) return Toastshow("Please enter sale price");
        if (!uid) return Toastshow("Please enter uid ");
        try {
            const result = await Product_sales_details_edit({
                uid,
                saleprice,
                salesname,
                salesurl,
            });
            if (result.success) {
                Toastshow("Saved sales successfully!");
                setSalesurl("");
                setSaleprice("");
                setSalesname("");
                setSalesurl("");

            } else {
                Toastshow("Error: " + (result.error || "Unknown error"));
            }
        } catch (error) {
            console.error("❌ Error submitting post:", error);
            Toastshow("Error submitting post: " + error.message);
        }
    };
    const [salesdata, setSalesdata] = useState([]);

    useEffect(() => {
        if (!uid) return;
        setIsLoading3(true);

        const productsQuery = query(collection(db, "products"), where("uid", "==", uid));

        // Keep track of all field listeners to clean up later
        const fieldUnsubscribers = [];

        const unsubscribeProducts = onSnapshot(productsQuery, (productSnap) => {
            if (productSnap.empty) {
                setSalesdata([]);
                setIsLoading3(false);
                return;
            }

            const allProducts = [];

            productSnap.docs.forEach((productDoc) => {
                const productData = { uid: productDoc.id, ...productDoc.data(), child: [] };
                allProducts.push(productData);

                // 👇 Listen to "fields" subcollection for each product
                const fieldsQuery = query(
                    collection(productDoc.ref, "fields"),
                    where("category", "==", "sales")
                );

                const unsubscribeFields = onSnapshot(fieldsQuery, (fieldsSnap) => {
                    const childData = fieldsSnap.docs.map((fieldDoc) => ({
                        id: fieldDoc.id,
                        ...fieldDoc.data(),
                    }));

                    // ✅ Update that specific product’s fields in real time
                    setSalesdata((prevData) => {
                        const updated = [...prevData];
                        const index = updated.findIndex((p) => p.uid === productDoc.id);

                        if (index !== -1) {
                            updated[index] = { ...updated[index], child: childData };
                        } else {
                            updated.push({ ...productData, child: childData });
                        }

                        return updated;
                    });
                });

                fieldUnsubscribers.push(unsubscribeFields);
            });

            // Initialize once with current products
            setSalesdata(allProducts);
            setIsLoading3(false);
        });

        // 🔁 Cleanup on unmount
        return () => {
            unsubscribeProducts();
            fieldUnsubscribers.forEach((unsub) => unsub());
        };
    }, [uid]);

    const fetchCategory = async () => {
        setIsLoading2(true);
        try {
            const categoryQuery = query(
                collection(db, "category"),
            );

            const snapshot = await getDocs(categoryQuery);
            const docs = await Promise.all(
                snapshot.docs.map(async (docSnap) => {
                    const docData = docSnap.data();
                    const fieldsSnap = await getDocs(collection(docSnap.ref, "fields"));
                    const subcategories = [];
                    fieldsSnap.forEach((fieldDoc) => {
                        const { fieldName, fieldValue } = fieldDoc.data();
                        if (fieldName === "subcategory" && fieldValue) {
                            subcategories.push(fieldValue);
                        }
                    });
                    return { uid: docSnap.id, category: docData.category, subcategories };
                })
            );

            setCategoryData(docs);
        } catch (err) {
            console.error("Error fetching categories:", err);
        }
        setIsLoading2(false);
    };

    useEffect(() => {
        fetchCategory();
    }, []);
    // Full CSS color list with hex values
    const cssColors = {
        "AliceBlue": "#F0F8FF",
        "AntiqueWhite": "#FAEBD7",
        "Aqua": "#00FFFF",
        "Aquamarine": "#7FFFD4",
        "Azure": "#F0FFFF",
        "Beige": "#F5F5DC",
        "Bisque": "#FFE4C4",
        "Black": "#000000",
        "BlanchedAlmond": "#FFEBCD",
        "Blue": "#0000FF",
        "BlueViolet": "#8A2BE2",
        "Brown": "#A52A2A",
        "BurlyWood": "#DEB887",
        "CadetBlue": "#5F9EA0",
        "Chartreuse": "#7FFF00",
        "Chocolate": "#D2691E",
        "Coral": "#FF7F50",
        "CornflowerBlue": "#6495ED",
        "Cornsilk": "#FFF8DC",
        "Crimson": "#DC143C",
        "Cyan": "#00FFFF",
        "DarkBlue": "#00008B",
        "DarkCyan": "#008B8B",
        "DarkGoldenRod": "#B8860B",
        "DarkGray": "#A9A9A9",
        "DarkGreen": "#006400",
        "DarkKhaki": "#BDB76B",
        "DarkMagenta": "#8B008B",
        "DarkOliveGreen": "#556B2F",
        "DarkOrange": "#FF8C00",
        "DarkOrchid": "#9932CC",
        "DarkRed": "#8B0000",
        "DarkSalmon": "#E9967A",
        "DarkSeaGreen": "#8FBC8F",
        "DarkSlateBlue": "#483D8B",
        "DarkSlateGray": "#2F4F4F",
        "DarkTurquoise": "#00CED1",
        "DarkViolet": "#9400D3",
        "DeepPink": "#FF1493",
        "DeepSkyBlue": "#00BFFF",
        "DimGray": "#696969",
        "DodgerBlue": "#1E90FF",
        "FireBrick": "#B22222",
        "FloralWhite": "#FFFAF0",
        "ForestGreen": "#228B22",
        "Fuchsia": "#FF00FF",
        "Gainsboro": "#DCDCDC",
        "GhostWhite": "#F8F8FF",
        "Gold": "#FFD700",
        "GoldenRod": "#DAA520",
        "Gray": "#808080",
        "Green": "#008000",
        "GreenYellow": "#ADFF2F",
        "HoneyDew": "#F0FFF0",
        "HotPink": "#FF69B4",
        "IndianRed": "#CD5C5C",
        "Indigo": "#4B0082",
        "Ivory": "#FFFFF0",
        "Khaki": "#F0E68C",
        "Lavender": "#E6E6FA",
        "LavenderBlush": "#FFF0F5",
        "LawnGreen": "#7CFC00",
        "LemonChiffon": "#FFFACD",
        "LightBlue": "#ADD8E6",
        "LightCoral": "#F08080",
        "LightCyan": "#E0FFFF",
        "LightGoldenRodYellow": "#FAFAD2",
        "LightGray": "#D3D3D3",
        "LightGreen": "#90EE90",
        "LightPink": "#FFB6C1",
        "LightSalmon": "#FFA07A",
        "LightSeaGreen": "#20B2AA",
        "LightSkyBlue": "#87CEFA",
        "LightSlateGray": "#778899",
        "LightSteelBlue": "#B0C4DE",
        "LightYellow": "#FFFFE0",
        "Lime": "#00FF00",
        "LimeGreen": "#32CD32",
        "Linen": "#FAF0E6",
        "Magenta": "#FF00FF",
        "Maroon": "#800000",
        "MediumAquaMarine": "#66CDAA",
        "MediumBlue": "#0000CD",
        "MediumOrchid": "#BA55D3",
        "MediumPurple": "#9370DB",
        "MediumSeaGreen": "#3CB371",
        "MediumSlateBlue": "#7B68EE",
        "MediumSpringGreen": "#00FA9A",
        "MediumTurquoise": "#48D1CC",
        "MediumVioletRed": "#C71585",
        "MidnightBlue": "#191970",
        "MintCream": "#F5FFFA",
        "MistyRose": "#FFE4E1",
        "Moccasin": "#FFE4B5",
        "NavajoWhite": "#FFDEAD",
        "Navy": "#000080",
        "OldLace": "#FDF5E6",
        "Olive": "#808000",
        "OliveDrab": "#6B8E23",
        "Orange": "#FFA500",
        "OrangeRed": "#FF4500",
        "Orchid": "#DA70D6",
        "PaleGoldenRod": "#EEE8AA",
        "PaleGreen": "#98FB98",
        "PaleTurquoise": "#AFEEEE",
        "PaleVioletRed": "#DB7093",
        "PapayaWhip": "#FFEFD5",
        "PeachPuff": "#FFDAB9",
        "Peru": "#CD853F",
        "Pink": "#FFC0CB",
        "Plum": "#DDA0DD",
        "PowderBlue": "#B0E0E6",
        "Purple": "#800080",
        "RebeccaPurple": "#663399",
        "Red": "#FF0000",
        "RosyBrown": "#BC8F8F",
        "RoyalBlue": "#4169E1",
        "SaddleBrown": "#8B4513",
        "Salmon": "#FA8072",
        "SandyBrown": "#F4A460",
        "SeaGreen": "#2E8B57",
        "SeaShell": "#FFF5EE",
        "Sienna": "#A0522D",
        "Silver": "#C0C0C0",
        "SkyBlue": "#87CEEB",
        "SlateBlue": "#6A5ACD",
        "SlateGray": "#708090",
        "Snow": "#FFFAFA",
        "SpringGreen": "#00FF7F",
        "SteelBlue": "#4682B4",
        "Tan": "#D2B48C",
        "Teal": "#008080",
        "Thistle": "#D8BFD8",
        "Tomato": "#FF6347",
        "Turquoise": "#40E0D0",
        "Violet": "#EE82EE",
        "Wheat": "#F5DEB3",
        "White": "#FFFFFF",
        "WhiteSmoke": "#F5F5F5",
        "Yellow": "#FFFF00",
        "YellowGreen": "#9ACD32"
    };

    // Convert hex to RGB
    function hexToRgb(hex) {
        hex = hex.replace(/^#/, "");
        if (hex.length === 3) {
            hex = hex.split("").map((c) => c + c).join("");
        }
        const num = parseInt(hex, 16);
        return [num >> 16, (num >> 8) & 255, num & 255];
    }

    // Find closest color name
    function getClosestColorName(hex) {
        hex = "#" + hex.replaceAll("#", "");
        const targetRgb = hexToRgb(hex);
        let closest = null;
        let minDist = Infinity;

        for (const [name, colorHex] of Object.entries(cssColors)) {
            const rgb = hexToRgb(colorHex);
            const dist = Math.sqrt(
                Math.pow(targetRgb[0] - rgb[0], 2) +
                Math.pow(targetRgb[1] - rgb[1], 2) +
                Math.pow(targetRgb[2] - rgb[2], 2)
            );

            if (dist < minDist) {
                minDist = dist;
                closest = name;
            }
        }

        return closest || "Unknown Color";
    }


    //setProductsdata
    const fetchproducts = async () => {
        setIsLoading(true);
        try {
            const companyuid = Cookies.get("select_company_uid");
            const guid = Cookies.get("guid");

            if (!companyuid || !guid) {
                console.error("Missing company UID or GUID");
                setIsLoading(false);
                return;
            }
            setIsLoading(true);
            const Query = query(
                collection(db, "products"),
                where("companyuid", "==", companyuid)
            );


            const snapshot = await getDocs(Query);
            const products = await Promise.all(
                snapshot.docs.map(async (docSnap) => {
                    const docData = docSnap.data();
                    const fieldsSnap = await getDocs(collection(docSnap.ref, "fields"));
                    let child = {};
                    fieldsSnap.forEach((fieldDoc) => {
                        const { fieldName, fieldValue } = fieldDoc.data();
                        child[fieldName] = fieldValue;
                    });
                    return { uid: docSnap.id, ...docData, child };
                })
            );

            setProductsdata(products);
            setModelname(products[0].modelname || "");
            setBrandname(products[0].brandname || "");
            setUsecase(products[0].usecase || "");
            setTitle(products[0].title || "");
            setDescription(products[0].description || "");
            setKeywords(products[0].keywords || "");
            setColor(products[0]?.color || "#000");
            setPrice(products[0]?.child?.price || "");
            setMrp(products[0]?.child?.mrp || "");
            setDiscount(products[0]?.child?.discount || "");
            setBenefit(products[0]?.child?.benefit || "");
            //services
            setDeliverycharges(products[0]?.child?.deliverycharges || "");
            setDeliverydays(products[0]?.child?.deliverydays || "");
            setWarranty(products[0]?.child?.warranty || false);
            setWarrantystatus(products[0]?.child?.warrantystatus || false);
            setNotreturnablestatus(products[0]?.child?.Notreturnablestatuss || false);
            setCashpayon(products[0]?.child?.cashpayon || "");
            //
            setIsLoading(false);
        } catch (err) {
            console.error("Error fetching products:", err);
        }
        setIsLoading(false);
    };
    useEffect(() => {
        // Fetch products whenever selectedCategory or selectedSubcategory changes
        fetchproducts();
    }, [selectedCategory, selectedSubcategory]);
    //change logo
    const [product_file, setProduct_file] = useState(null);
    const product_file_Upload = async () => {
        if (!product_file) return;

        if (!Cookies.get("guid")) return Toastshow("Please login");
        if (!Cookies.get("select_company_uid")) return Toastshow("Please select company");

        // ⚡ Pass the uid of the company you’re editing
        const result = await Product_uploader_files({
            file: product_file,
            fileuid: uid,
            fileslimit: 10,
            tablename: "products",
            filename: "product",
        });

        if (result.success) {
            Toastshow("Successfully!");
            setProduct_file(null);

            setViewfile_url("");
        } else {

            setProduct_file(null);
            Toastshow(`Error: ${result.error}`);
        }
    };

    useEffect(() => {
        if (product_file) {
            product_file_Upload();
        }
    }, [product_file]);
    //fetch product file
    useEffect(() => {
        let unsubscribe;

        const fetch_product_file = () => {
            setIsLoading(true);

            try {
                const companyuid = Cookies.get("select_company_uid");
                const guid = Cookies.get("guid");

                if (!companyuid || !guid) {
                    console.error("Missing company UID or GUID");
                    setIsLoading(false);
                    return;
                }

                const Query = query(
                    collection(db, "files"),
                    where("companyuid", "==", companyuid),
                    where("filename", "==", "product"),
                    where("fileuid", "==", uid)
                );

                // Real-time listener
                unsubscribe = onSnapshot(
                    Query,
                    (snapshot) => {
                        const datafiles = snapshot.docs.map((doc) => ({
                            id: doc.id,
                            ...doc.data(),
                        }));
                        setProduct_filedata(datafiles);
                        setIsLoading(false);
                    },
                    (err) => {
                        console.error("Error listening to file data:", err);
                        setIsLoading(false);
                    }
                );
            } catch (err) {
                console.error("Error fetching file data:", err);
                setIsLoading(false);
            }
        };

        fetch_product_file();

        // Cleanup subscription on unmount or uid change
        return () => {
            if (unsubscribe) unsubscribe();
        };
    }, [uid]);


    //From the manufacturer banner
    const [isLoadingm, setIsLoadingm] = useState(true);
    const [viewManufacturerfile_url, setViewManufacturerfile_url] = useState("");
    const [manufacturer_file, setManufacturer_file] = useState(null);
    const manufacturer_file_Upload = async () => {
        if (!manufacturer_file) return;

        if (!Cookies.get("guid")) return Toastshow("Please login");
        if (!Cookies.get("select_company_uid")) return Toastshow("Please select company");
        setIsLoadingm(true)
        // ⚡ Pass the uid of the company you’re editing
        const result = await Product_uploader_files({
            file: manufacturer_file,
            fileuid: uid,
            fileslimit: 2,
            tablename: "products",
            filename: "manufacturer",
        });

        if (result.success) {
            Toastshow("Successfully!");
            setManufacturer_file(null);
            setViewManufacturerfile_url("");
        } else {
            setManufacturer_file(null);
            setViewManufacturerfile_url("");
            Toastshow(`Error: ${result.error}`);
        }
    };
    useEffect(() => {
        if (manufacturer_file) {
            manufacturer_file_Upload();
        }
    }, [manufacturer_file]);


    const [manufacturer_filedata, setManufacturer_filedata] = useState([]);
    //fetch product file
    useEffect(() => {
        let unsubscribe;

        const fetch_product_file = () => {
            setIsLoading(true);

            try {
                const companyuid = Cookies.get("select_company_uid");
                const guid = Cookies.get("guid");

                if (!companyuid || !guid) {
                    console.error("Missing company UID or GUID");
                    setIsLoading(false);
                    return;
                }

                const Query = query(
                    collection(db, "files"),
                    where("companyuid", "==", companyuid),
                    where("filename", "==", "manufacturer"),
                    where("fileuid", "==", uid)
                );

                // Real-time listener
                unsubscribe = onSnapshot(
                    Query,
                    (snapshot) => {
                        const datafiles = snapshot.docs.map((doc) => ({
                            id: doc.id,
                            ...doc.data(),
                        }));
                        setManufacturer_filedata(datafiles);
                        setIsLoading(false);
                    },
                    (err) => {
                        console.error("Error listening to file data:", err);
                        setIsLoading(false);
                    }
                );
            } catch (err) {
                console.error("Error fetching file data:", err);
                setIsLoading(false);
            }
        };

        fetch_product_file();

        // Cleanup subscription on unmount or uid change
        return () => {
            if (unsubscribe) unsubscribe();
        };
    }, [uid]);


    //reviewslideshow

    const [viewreviewslideshowfile_url, setViewreviewslideshowfile_url] = useState("");
    const [reviewslideshow_file, setReviewslideshow_file] = useState(null);
    const reviewslideshow_file_Upload = async () => {
        if (!reviewslideshow_file) return;

        if (!Cookies.get("guid")) return Toastshow("Please login");
        if (!Cookies.get("select_company_uid")) return Toastshow("Please select company");
        setIsLoadingm(true)
        // ⚡ Pass the uid of the company you’re editing
        const result = await Product_uploader_files({
            file: reviewslideshow_file,
            fileuid: uid,
            fileslimit: 4,
            tablename: "products",
            filename: "reviewslideshow",
        });

        if (result.success) {
            Toastshow("Successfully!");
            setReviewslideshow_file(null);
            setViewreviewslideshowfile_url("");
        } else {
            setReviewslideshow_file(null);
            setViewreviewslideshowfile_url("");
            Toastshow(`Error: ${result.error}`);
        }
    };
    useEffect(() => {
        if (reviewslideshow_file) {
            reviewslideshow_file_Upload();
        }
    }, [reviewslideshow_file]);


    const [review_slideshow_filedata, setReview_slideshow_filedata] = useState([]);
    //fetch product file
    useEffect(() => {
        let unsubscribe;

        const fetch_product_file = () => {
            setIsLoading(true);

            try {
                const companyuid = Cookies.get("select_company_uid");
                const guid = Cookies.get("guid");

                if (!companyuid || !guid) {
                    console.error("Missing company UID or GUID");
                    setIsLoading(false);
                    return;
                }

                const Query = query(
                    collection(db, "files"),
                    where("companyuid", "==", companyuid),
                    where("filename", "==", "reviewslideshow"),
                    where("fileuid", "==", uid)
                );

                // Real-time listener
                unsubscribe = onSnapshot(
                    Query,
                    (snapshot) => {
                        const datafiles = snapshot.docs.map((doc) => ({
                            id: doc.id,
                            ...doc.data(),
                        }));
                        setReview_slideshow_filedata(datafiles);
                        setIsLoading(false);
                    },
                    (err) => {
                        console.error("Error listening to file data:", err);
                        setIsLoading(false);
                    }
                );
            } catch (err) {
                console.error("Error fetching file data:", err);
                setIsLoading(false);
            }
        };

        fetch_product_file();

        // Cleanup subscription on unmount or uid change
        return () => {
            if (unsubscribe) unsubscribe();
        };
    }, [uid]);
    //
    //PPT Photos

    const [pptphotoshowfile_url, setPPTPhotoshowfile_url] = useState("");
    const [pptphotoshowf_file, setPptphotoshowf_file] = useState(null);
    const pptphotoshowf_file_Upload = async () => {
        if (!pptphotoshowf_file) return;

        if (!Cookies.get("guid")) return Toastshow("Please login");
        if (!Cookies.get("select_company_uid")) return Toastshow("Please select company");
        setIsLoadingm(true)
        // ⚡ Pass the uid of the company you’re editing
        const result = await Product_uploader_files({
            file: pptphotoshowf_file,
            fileuid: uid,
            fileslimit: 20,
            tablename: "products",
            filename: "pptphotoshow",
        });

        if (result.success) {
            setPPTPhotoshowfile_url(null);
            setPptphotoshowf_file(null);
            Toastshow("Successfully!");

        } else {
            setPptphotoshowf_file("");
            setPPTPhotoshowfile_url(null);

            Toastshow(`Error: ${result.error}`);
        }
    };
    useEffect(() => {
        if (pptphotoshowf_file) {
            pptphotoshowf_file_Upload();
        }
    }, [pptphotoshowf_file]);
   //fetch product file
    const [pptphotoshowf_file_filedata, setPptphotoshowf_file_filedata] = useState([]);
    useEffect(() => {
        let unsubscribe;

        const fetch_product_file = () => {
            setIsLoading(true);

            try {
                const companyuid = Cookies.get("select_company_uid");
                const guid = Cookies.get("guid");

                if (!companyuid || !guid) {
                    console.error("Missing company UID or GUID");
                    setIsLoading(false);
                    return;
                }

                const Query = query(
                    collection(db, "files"),
                    where("companyuid", "==", companyuid),
                    where("filename", "==", "pptphotoshow"),
                    where("fileuid", "==", uid)
                );

                // Real-time listener
                unsubscribe = onSnapshot(
                    Query,
                    (snapshot) => {
                        const datafiles = snapshot.docs.map((doc) => ({
                            id: doc.id,
                            ...doc.data(),
                        }));
                       setPptphotoshowf_file_filedata(datafiles);
                        setIsLoading(false);
                    },
                    (err) => {
                        console.error("Error listening to file data:", err);
                        setIsLoading(false);
                    }
                );
            } catch (err) {
                console.error("Error fetching file data:", err);
                setIsLoading(false);
            }
        };

        fetch_product_file();

        // Cleanup subscription on unmount or uid change
        return () => {
            if (unsubscribe) unsubscribe();
        };
    }, [uid]);
    //Explanation

    const [explanationfile_url, setExplanationfile_url] = useState("");
    const [explanation_file, setExplanation_file] = useState(null);
    const Explanation_file_Upload = async () => {
        if (!explanation_file) return;

        if (!Cookies.get("guid")) return Toastshow("Please login");
        if (!Cookies.get("select_company_uid")) return Toastshow("Please select company");
        setIsLoadingm(true)
        // ⚡ Pass the uid of the company you’re editing
        const result = await Product_uploader_files({
            file: explanation_file,
            fileuid: uid,
            fileslimit: 20,
            tablename: "products",
            filename: "explanation",
        });

        if (result.success) {
            setExplanationfile_url(null);
            setExplanation_file(null);
            Toastshow("Successfully!");
        } else {
            setExplanationfile_url(null);
            setExplanation_file(null);
            Toastshow(`Error: ${result.error}`);
        }
    };
    useEffect(() => {
        if (explanation_file) {
            Explanation_file_Upload();
        }
    }, [explanation_file]);

    const [explanation_filedata, setExplanation_filedata] = useState([]);
    //fetchexplanation file
    useEffect(() => {
        let unsubscribe;

        const fetch_product_file = () => {
            setIsLoading(true);

            try {
                const companyuid = Cookies.get("select_company_uid");
                const guid = Cookies.get("guid");

                if (!companyuid || !guid) {
                    console.error("Missing company UID or GUID");
                    setIsLoading(false);
                    return;
                }

                const Query = query(
                    collection(db, "files"),
                    where("companyuid", "==", companyuid),
                    where("filename", "==", "explanation"),
                    where("fileuid", "==", uid)
                );

                // Real-time listener
                unsubscribe = onSnapshot(
                    Query,
                    (snapshot) => {
                        const datafiles = snapshot.docs.map((doc) => ({
                            id: doc.id,
                            ...doc.data(),
                        }));
                       setExplanation_filedata(datafiles);
                        setIsLoading(false);
                    },
                    (err) => {
                        console.error("Error listening to file data:", err);
                        setIsLoading(false);
                    }
                );
            } catch (err) {
                console.error("Error fetching file data:", err);
                setIsLoading(false);
            }
        };

        fetch_product_file();

        // Cleanup subscription on unmount or uid change
        return () => {
            if (unsubscribe) unsubscribe();
        };
    }, [uid]);


    const set_uid_delete = async (tablename, uid) => {
        if (uid.length > 10) {
            try {
                const docRef = doc(db, tablename, uid);
                await deleteDoc(docRef); // ✅ correct Firestore delete function
                Toastshow("Deleted successfully");
            } catch (error) {
                console.error("Error deleting document:", error);
                Toastshow("Delete failed");
            }
        } else {
            Toastshow("Value is null");
        }
    };

    const set_child_uid_delete = async (tablename, parentId, childCollection, childId) => {
        // parentId = UID of the parent document
        // childCollection = name of the subcollection
        // childId = UID of the child document to delete

        if (childId && childId.length > 0) {
            try {
                const childDocRef = doc(db, tablename, parentId, childCollection, childId);
                await deleteDoc(childDocRef); // ✅ deletes the child document
                Toastshow("Deleted successfully");
            } catch (error) {
                console.error("Error deleting document:", error);
                Toastshow("Delete failed");
            }
        } else {
            Toastshow("Child ID is null or invalid");
        }
    };
    const set_status_change = async (uid, column_name) => {
        try {
            // const column_name = "status";
            const masterQuery = query(
                collection(db, "products"),
                where("uid", "==", uid)
            );
            const masterSnap = await getDocs(masterQuery);

            for (const masterDoc of masterSnap.docs) {
                const currentData = masterDoc.data();
                const newValue = !(currentData[column_name] ?? false); // toggle

                const docRef = doc(db, "products", masterDoc.id);
                await updateDoc(docRef, {
                    [column_name]: newValue,
                });
            }
            Toastshow("Successfully!");
            fetchproducts();
        } catch (error) {
            console.error("Error toggling mode:", error);
        }
    };


    useEffect(() => {
        fetchtechnicalFields();
    }, [uid]);

    return (

        <div >
            <table className="border-bottom p-1" >
                <tr>
                    <td width={30}><div className="p-2 cursor"

                        onClick={() => {
                            navigate("?menu=productslist");
                            window.location.reload();
                        }}
                    ><MdArrowBackIos className="icon" /></div></td>
                    <td className="text-h2 bold">Edit Product</td>
                    <td width={30}><div className="p-2"
                    ><MdStarBorder className="icon" /></div></td>
                </tr>
            </table>

            <br />
            <div className="ui-items items-back  border-bottom">
                <table>
                    <tr>
                        <th className="text-h3">Status </th>
                        <th className="text-h3">Vister</th>
                        <th className="text-h3">Order</th>
                        <th className="text-h3">I agree</th>
                    </tr>
                    <tr>

                        <td>
                            <div onClick={() => set_status_change(productsdata[0]?.uid, "status")}
                                className={`button-ui2 cursor border p-1 ${productsdata[0]?.status === true ? "green" : "red"}`}
                            >
                                {productsdata[0]?.status === true ? "Publish" : "Deactivate"}
                            </div>
                        </td>


                        <td>
                            <div className="button-ui1"><MdVisibility className="icon" /> {productsdata[0]?.views || "0"} Views</div>   </td>

                        <td>
                            <div className="button-ui1"><MdOutlineShoppingCartCheckout className="icon" /> {productsdata[0]?.orders || "0"}</div>
                        </td>
                        <td width={80}>
                            <table >
                                <tr>
                                    <td >
                                        <input type='Checkbox'></input>
                                    </td>
                                    <td>
                                        <div className="button-ui2 border cursor fill"><MdDeleteOutline className="icon" />Delete</div></td>
                                </tr>

                            </table>

                        </td>
                    </tr>

                </table>


            </div>
            <br />
            <div className="container_size p-3">
                <div className="tabs-body">
                    <div
                        className={`tabsbutton ${activeTab === "product" ? "active" : ""}`}
                        onClick={() => {
                            setActiveTab("product");
                        }}
                    >
                        <a className="tabs-text">Product</a>
                    </div>
                    <div
                        className={`tabsbutton ${activeTab === "description" ? "active" : ""}`}
                        onClick={() => {
                            setActiveTab("description");
                        }}
                    >
                        <span className="tabs-text">Description</span>
                    </div>
                    <div
                        className={`tabsbutton ${activeTab === "technical" ? "active" : ""}`}
                        onClick={() => {
                            setActiveTab("technical");
                        }}
                    >
                        <span className="tabs-text">Technical </span>
                    </div>
                    <div
                        className={`tabsbutton ${activeTab === "additional" ? "active" : ""}`}
                        onClick={() => {
                            setActiveTab("additional");
                        }}
                    >
                        <span className="tabs-text">Additional</span>
                    </div>
                    <div
                        className={`tabsbutton ${activeTab === "media" ? "active" : ""}`}
                        onClick={() => {
                            setActiveTab("media");
                        }}
                    >
                        <span className="tabs-text">Media</span>
                    </div>
                </div>

            </div>

            {activeTab === "product" && (
                <div className="post-container">

                    <div className="post_div"  >
                        <div className="ui-grid">


                            <div className="ui-items items-back  border rounded p-2">
                                <div className="text-h2 bold  p-1">Product Price : Inclusive of all taxe </div>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td className="text-h3">Price</td>
                                            <td ><input className="text-h2 fcap bold"
                                                value={price}
                                                maxLength={20}
                                                onChange={(e) => setPrice(e.target.value)}
                                            /></td>
                                        </tr>
                                        <tr>
                                            <td className="text-h3">M.R.P</td>
                                            <td>
                                                <input
                                                    className="text-h2 fcap bold"
                                                    maxLength={20}
                                                    value={mrp}
                                                    onChange={(e) => {
                                                        const newMrp = parseFloat(e.target.value) || 0;
                                                        setMrp(newMrp);

                                                        const newPrice = parseFloat(price) || 0;

                                                        if (newMrp > 0 && newPrice > 0 && newPrice <= newMrp) {
                                                            const discountPercent = Math.round(((newMrp - newPrice) / newMrp) * 100);
                                                            setDiscount(discountPercent);
                                                            setBenefit(newMrp - newPrice);
                                                        } else {
                                                            setDiscount(0);
                                                            setBenefit(0);
                                                        }
                                                    }}
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-h3">Offer Discount</td>
                                            <td   ><div className="text-h2 fcap red bold"


                                            >{discount}%</div></td>
                                        </tr>
                                        <tr>
                                            <td className="text-h3">Deal name</td>
                                            <td width={150} ><input className="text-h2 fcap bold"
                                                value={dealname}
                                                maxLength={30}
                                                placeholder="Great Indian Festival"
                                                onChange={(e) => setDealname(e.target.value)}

                                            /></td>
                                        </tr>
                                        <tr>
                                            <td className="text-h3">Benefit amount </td>
                                            <td ><input className="text-h2 fcap bold"
                                                value={benefit}
                                                maxLength={20}
                                                onChange={(e) => setBenefit(e.target.value)} /></td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div onClick={Save_Product_price_edit} className="button-ui2 fill p-1 text-h2 cursor"><MdAdd className="icon" />Save</div>
                            </div>
                            <div className="ui-items items-back  border rounded p-2">
                                <div className="text-h2 bold  p-1">Product services</div>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td className="text-h3">Charges</td>
                                            <td ><input className="text-h2 fcap bold"
                                                value={deliverycharges}
                                                maxLength={20}
                                                onChange={(e) => setDeliverycharges(e.target.value)}
                                            /></td>
                                        </tr>
                                        <tr>
                                            <td className="text-h3">Days</td>
                                            <td ><input className="text-h2 fcap bold"
                                                maxLength={20}
                                                value={deliverydays}
                                                onChange={(e) => setDeliverydays(e.target.value)} /></td>
                                        </tr>
                                        <tr>
                                            <td className="text-h3">Warranty info</td>
                                            <td   ><input className="text-h2 fcap bold"
                                                value={warranty}
                                                placeholder="1 Year Warranty"
                                                maxLength={30}
                                                onChange={(e) => setWarranty(e.target.value)}

                                            /></td>
                                        </tr>
                                        <tr>
                                            <td className="text-h3">Returnable</td>
                                            <td width={150} >
                                                <Select_yes_no
                                                    checked={notreturnablestatus}
                                                    onChange={(e) => setNotreturnablestatus(!notreturnablestatus)}

                                                /></td>
                                        </tr>
                                        <tr>
                                            <td className="text-h3">Warranty</td>
                                            <td width={150} >
                                                <Select_yes_no
                                                    checked={warrantystatus}
                                                    onChange={(e) => setWarrantystatus(!warrantystatus)}

                                                /></td>
                                        </tr>
                                        <tr>
                                            <td className="text-h3">Cash/Pay on</td>
                                            <td width={150} >
                                                <Select_yes_no
                                                    checked={cashpayon}
                                                    onChange={(e) => setCashpayon(!cashpayon)}

                                                /></td>
                                        </tr>

                                    </tbody>
                                </table>
                                <div onClick={Save_Product_services_edit} className="button-ui2 cursor fill p-1 text-h2"><MdAdd className="icon" />Save</div>
                            </div>
                            <div className="ui-items items-back border rounded p-2">
                                <div className="text-h2 bold  p-1">Item Details</div>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td width={70} className="text-h3">Color</td>
                                            <td><table >
                                                <tr>
                                                    <td>
                                                        <input className="border text-h2 p-11" value={color}
                                                            onChange={(e) => {
                                                                setColor(e.target.value);

                                                                setColorname(getClosestColorName(e.target.value));
                                                            }} />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="color"
                                                            style={{ width: "60px" }}
                                                            className="cursor border-none p-0 text-h2 fcap bold"
                                                            value={color}
                                                            onChange={(e) => setColor(e.target.value)} // update state
                                                        />
                                                    </td>
                                                </tr>
                                            </table>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-h3">Color name</td>
                                            <td  ><input className="text-h2 fcap bold" value={colorname}
                                                onChange={(e) => setColorname(e.target.value)}
                                            /></td>
                                        </tr>
                                        <tr>
                                            <td className="text-h3">Packing</td>
                                            <td ><input className="text-h2 fcap bold" value={packingitem}
                                                onChange={(e) => setPackingitem(e.target.value)}
                                            /></td>
                                        </tr>

                                    </tbody>
                                </table>
                                <div onClick={Save_Product_item_details_edit} className="button-ui2 cursor fill p-1 text-h2"><MdAdd className="icon" />Save</div>
                            </div>

                            <div className="ui-items items-back border rounded p-2">
                                <div className="text-h2 bold  p-1">Sales details </div>
                                <div className="m-top">
                                    {isLoading3 ? (
                                        <Lodinging />
                                    ) : salesdata.length === 0 ? (
                                        <div>No sales found</div>
                                    ) : (
                                        <table className="table-sales">
                                            <thead>
                                                <tr>
                                                    <th>Name</th>
                                                    <th>Price</th>
                                                    <th>URL</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {salesdata.map((product, pIndex) =>
                                                    product.child && product.child.length > 0 ? (
                                                        product.child.map((field, fIndex) => (
                                                            <tr key={`${pIndex}-${fIndex}`}>
                                                                <td>
                                                                    <div className="text-h2 fcap">{field.salesname}</div>
                                                                </td>
                                                                <td>
                                                                    <div className="text-h2 fcap">{field.saleprice}</div>
                                                                </td>
                                                                <td>
                                                                    <a
                                                                        className="text-h4 sline"
                                                                        href={field.salesurl}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                    >
                                                                        {field.salesurl}
                                                                    </a>
                                                                </td>
                                                                <td width={30}>
                                                                    <div
                                                                        className="button_ui cursor"
                                                                        onClick={() =>
                                                                            set_child_uid_delete("products", product.uid, "fields", field.id)
                                                                        }
                                                                    >
                                                                        <MdDeleteOutline className="icon red" />
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr key={`nochild-${pIndex}`}>
                                                            <td colSpan="4" className="text-center text-off">
                                                                No sales fields found for this product
                                                            </td>
                                                        </tr>
                                                    )
                                                )}
                                            </tbody>
                                        </table>
                                    )}
                                </div>

                                <table>
                                    <tbody>
                                        <tr>

                                            <td className="text-h3">Price</td>

                                            <td className="text-h3" width={90}>Name</td>
                                        </tr>

                                        <tr>

                                            <td ><input type="text"
                                                value={salesname}
                                                onChange={(e) => {
                                                    const cleanValue = e.target.value.replace(/[^a-zA-Z0-9_\s]/g, "");
                                                    setSalesname(cleanValue);
                                                }}
                                                className="text-h2 bold" placeholder="Name" /></td>
                                            <td ><input type="text"
                                                value={saleprice}
                                                onChange={(e) => {
                                                    const cleanValue = e.target.value.replace(/[^0-9]/g, "");
                                                    setSaleprice(cleanValue);
                                                }}
                                                className="text-h2 bold" placeholder="Price" /></td>


                                        </tr>
                                        <tr>
                                            <td ><input type="text"

                                                value={salesurl}
                                                onChange={(e) => {
                                                    setSalesurl(e.target.value);

                                                }}
                                                className="text-h2 bold" placeholder="URL Link" /></td>
                                            <td>
                                                <div onClick={Save_product_sales_details_edit} className="button-ui fill cursor p-11 text-h2"><MdAdd className="icon" />Save</div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>
                        </div>
                    </div>
                </div>
            )}
            {activeTab === "description" && (
                <div className="ui-grid-fill ">
                    {isLoading ? (
                        <Lodinging />
                    ) : productsdata.length === 0 ? (
                        <div>No categories found</div>
                    ) : (
                        productsdata.map((row, index) => (
                            <div className="ui-items items-back " key={index}>
                                <table>
                                    <tbody>

                                        <tr>
                                            <td className="text-h3">Create</td>
                                            <td>
                                                {row.date_time?.toDate
                                                    ? row.date_time.toDate().toLocaleString("en-IN", {
                                                        day: "2-digit",
                                                        month: "short",
                                                        year: "numeric",
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                    })
                                                    : "No data"}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-h3">Category</td>
                                            <td ><div className="text-h3 fcap bold">{row.category}/ {row.subcategory}</div></td>
                                        </tr>
                                        <tr>
                                            <td className="text-h3">Subcategory</td>
                                            <td ><div className="text-h3 fcap bold">{row.subcategory}</div></td>
                                        </tr>
                                        <tr>
                                            <td className="text-h3">Item name</td>
                                            <td ><div className="text-h2 fcap bold">{row.item}</div></td>
                                        </tr>

                                        <tr>
                                            <td width={80} className="text-h3">Brand name</td>
                                            <td className="text-h2 bold"><input value={brandname} maxLength={50} onChange={(e) => setBrandname(e.target.value)} type="text" placeholder="Brand name" /></td>
                                        </tr>
                                        <tr>
                                            <td width={80} className="text-h3">Model name</td>
                                            <td className="text-h2 bold"><input value={modelname} maxLength={50} onChange={(e) => setModelname(e.target.value)} type="text" placeholder="Model name" /></td>
                                        </tr>
                                        <tr>
                                            <td width={80} className="text-h3">Use case</td>
                                            <td className="text-h2 bold"><input value={usecase} maxLength={50} onChange={(e) => setUsecase(e.target.value)} type="text" placeholder="Model name" /></td>
                                        </tr>

                                        <tr>
                                            <td className="text-h3">Title</td>
                                            <td><div className="text-h3  ">
                                                <textarea
                                                    maxLength={200}
                                                    value={title}
                                                    onChange={(e) => setTitle(e.target.value)}
                                                    className="fill"
                                                />

                                            </div></td>
                                        </tr>
                                        <tr>

                                            <td className="text-h3">description</td>
                                            <td>

                                                <div className="w-full">
                                                    <textarea
                                                        placeholder="Write description..."
                                                        maxLength={2000}
                                                        value={description}
                                                        onChange={(e) => {
                                                            setDescription(e.target.value);
                                                            // auto resize
                                                            e.target.style.height = "auto";
                                                            e.target.style.height = e.target.scrollHeight + "px";
                                                        }}
                                                        className="p-1 text-pre"
                                                    />
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-h3">Keyword</td>
                                            <td><div className="text-h3  "><textarea rows={5} placeholder="description" maxLength={200} value={keywords}
                                                onChange={(e) => setKeywords(e.target.value)} className="fill" ></textarea></div></td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div  >
                                    <br />

                                    <div onClick={Save_productsedit} className="button-ui2 border cursor "><MdAdd className="icon" />Save Changes</div>
                                    {/* <div className="text-h2 bold red">Delete Product</div>
                                        <table >
                                            <tr>
                                                <td width={90}>
                                                    <input checked={agreeDelete}
                                                        onChange={() => setAgreeDelete(!agreeDelete)} type='Checkbox' ></input>
                                                </td>
                                                <td>
                                                    <div className="contact-title-div">
                                                        <div className="text-h3 text-off"> I understand and agree to Delete</div>

                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="text-h3"><div>Delete</div></td>
                                                <td >
                                                    <div
                                                        onClick={() => {
                                                            if (agreeDelete) {
                                                                set_uid_delete("products", row.uid);
                                                            } else {
                                                                Toast("Please agree to delete first!");
                                                            }
                                                        }}
                                                        className="button-ui2 border cursor"
                                                    >
                                                        <MdDeleteForever className="icon" />
                                                        Delete
                                                    </div>
                                                </td>
                                            </tr>

                                        </table> */}
                                </div>

                            </div>
                        ))
                    )}
                </div>
            )}
            {activeTab === "technical" && (
                <div >

                    <div className="ui-grid-fill ">
                        {isLoading ? (
                            <Lodinging />
                        ) : productsdata.length === 0 ? (
                            <div>No categories found</div>
                        ) : (
                            productsdata.map((row, index) => (
                                <div className="ui-items items-back " key={index}>

                                    <div className="text-h2 bold">Technical Details</div>
                                    <td width={150}><input className="text-h2 fcap bold"

                                        placeholder="Enter details"
                                        maxLength={30}
                                        value={detailstitle}
                                        onChange={(e) => {
                                            const cleanValue = e.target.value.replace(/[^a-zA-Z0-9_\s]/g, "");
                                            setDetailstitle(cleanValue);
                                        }}
                                    /></td>
                                    <table>
                                        <tr>
                                            <td >Field title</td>
                                            <td className="text-h3">Field value</td>
                                        </tr>
                                        <tr>
                                            <td width={150}><input className="text-h3"

                                                placeholder="Enter text (no spaces or special chars)"
                                                maxLength={30}
                                                value={technical}
                                                onChange={(e) => {
                                                    const cleanValue = e.target.value.replace(/[^a-zA-Z0-9_\s]/g, "");
                                                    setTechnical(cleanValue);
                                                }}
                                            /></td>
                                            <td><input className="text-h2" maxLength={200}

                                                value={technicalvalue}
                                                onChange={(e) => setTechnicalvalue(e.target.value)}
                                                placeholder="Field value" /></td>
                                            <td width={80}><div onClick={Save_Product__technical_details_edit} className="button-ui fill text-h2 cursor" ><MdAdd className="icon" />Save</div></td>
                                        </tr>
                                    </table>

                                </div>
                            ))
                        )}
                    </div>

                    <br />
                    <div className="">
                        <div className="b-1">
                            <div className="text-h1 bold fcap p-2 items-back-fill">
                                Technical Details
                            </div>
                            <div className="b-top">
                                {isLoading3 ? (
                                    <Lodinging />
                                ) : technicaldata.length === 0 ? (
                                    <div>No additional found</div>
                                ) : (
                                    technicaldata.map((product, pIndex) => {
                                        // 🔹 Group fields by details value
                                        const grouped = {};
                                        product.child.forEach((field) => {
                                            const groupKey = field.details || "Other";
                                            if (!grouped[groupKey]) grouped[groupKey] = [];
                                            grouped[groupKey].push(field);
                                        });

                                        return (
                                            <div key={pIndex} className="b-section">
                                                {Object.entries(grouped).map(([detailsValue, fields], gIndex) => (
                                                    <div key={`${pIndex}-group-${gIndex}`} className="b-top">
                                                        {/* 🔹 DETAILS HEADER */}
                                                        <div className=" p-1 items-back-fill">
                                                            <table >
                                                                <tr>
                                                                    <td width={22}>
                                                                        <MdInfoOutline className="icon" />
                                                                    </td>
                                                                    <td>
                                                                        <div className="text-h1 bold fcap">
                                                                            {detailsValue}
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </div>

                                                        {/* 🔹 FIELDS UNDER THIS DETAILS */}
                                                        {fields.map((field, fIndex) => (
                                                            <div className="b-top p-1" key={`${pIndex}-field-${fIndex}`}>
                                                                <table>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td width={22}>
                                                                                <MdArrowRight className="icon" />
                                                                            </td>
                                                                            <td width={210}>
                                                                                <div className="text-h2  fcap">
                                                                                    {field.fieldName.replaceAll("_", " ")}
                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                                <div className="text-h2">{field.fieldValue}</div>
                                                                            </td>
                                                                            <td width={30}><div className="button_ui cursor" onClick={() =>
                                                                                set_child_uid_delete("products", uid, "fields", field.id)
                                                                            }><MdDeleteOutline className="icon red" /></div></td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        ))}
                                                    </div>
                                                ))}
                                            </div>
                                        );
                                    })
                                )}
                            </div>
                        </div>


                    </div>
                </div>
            )}
            {activeTab === "additional" && (
                <div  >
                    <div className=" items-back m-bottom"  >
                        <div className="text-h2 bold">Additional Information</div>
                        <td width={150}><input className="text-h2 fcap bold"

                            placeholder="Enter details"
                            maxLength={30}
                            value={detailstitle}
                            onChange={(e) => {
                                const cleanValue = e.target.value.replace(/[^a-zA-Z0-9_\s]/g, "");
                                setDetailstitle(cleanValue);
                            }}
                        /></td>
                        <table>
                            <tr>
                                <td className="text-h3" width={150}>Field title</td>
                                <td className="text-h3">Field value</td>
                                <td>Save</td>
                            </tr>
                            <tr>
                                <td><input className="text-h3"

                                    placeholder="Enter text (no spaces or special chars)"
                                    maxLength={110}
                                    value={additional}
                                    onChange={(e) => {
                                        const cleanValue = e.target.value.replace(/[^a-zA-Z0-9_\s]/g, "");
                                        setAdditional(cleanValue);
                                    }}
                                /></td>
                                <td><input className="text-h2" maxLength={200}

                                    value={additionalvalue}
                                    onChange={(e) => setAdditionalvalue(e.target.value)}
                                    placeholder="Field value" /></td>

                                <td width={80}><div onClick={Save_Product_additional_details_edit} className="button-ui fill text-h2 cursor"><MdAdd className="icon" />Save</div></td>
                            </tr>
                        </table>
                    </div>
                    <br />
                    <div className="">
                        <div className="b-1">
                            <div className="text-h1 bold fcap p-2 items-back-fill">
                                Additional Information
                            </div>
                            <div className="b-top">
                                {isLoading3 ? (
                                    <Lodinging />
                                ) : additionaldata.length === 0 ? (
                                    <div>No additional found</div>
                                ) : (
                                    additionaldata.map((product, pIndex) => {
                                        // 🔹 Group fields by details value
                                        const grouped = {};
                                        product.child.forEach((field) => {
                                            const groupKey = field.details || "Other";
                                            if (!grouped[groupKey]) grouped[groupKey] = [];
                                            grouped[groupKey].push(field);
                                        });

                                        return (
                                            <div key={pIndex} className="b-section">
                                                {Object.entries(grouped).map(([detailsValue, fields], gIndex) => (
                                                    <div key={`${pIndex}-group-${gIndex}`} className="b-top">
                                                        {/* 🔹 DETAILS HEADER */}
                                                        <div className=" p-1 items-back-fill">
                                                            <table >
                                                                <tr>
                                                                    <td width={22}>
                                                                        <MdInfoOutline className="icon" />
                                                                    </td>
                                                                    <td>
                                                                        <div className="text-h1 bold fcap">
                                                                            {detailsValue}
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </div>

                                                        {/* 🔹 FIELDS UNDER THIS DETAILS */}
                                                        {fields.map((field, fIndex) => (
                                                            <div className="b-top p-1" key={`${pIndex}-field-${fIndex}`}>
                                                                <table>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td width={22}>
                                                                                <MdArrowRight className="icon" />
                                                                            </td>
                                                                            <td width={210}>
                                                                                <div className="text-h2  fcap">
                                                                                    {field.fieldName.replaceAll("_", " ")}
                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                                <div className="text-h2">{field.fieldValue}</div>
                                                                            </td>
                                                                            <td width={30}><div className="button_ui cursor" onClick={() =>
                                                                                set_child_uid_delete("products", uid, "fields", field.id)
                                                                            }><MdDeleteOutline className="icon red" /></div></td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        ))}
                                                    </div>
                                                ))}
                                            </div>
                                        );
                                    })
                                )}
                            </div>
                        </div>




                    </div>
                </div>
            )}
            {activeTab === "media" && (
                <div>
                    <div className="ui-grid-150">
                        <div className="ui-items items-back  border rounded"  >
                            <img src={viewfile_url || logo_default} className="logo_default" />
                            <div className="border-top flex center">
                                {product_file !== null ? (
                                    <Lodingingimg />
                                ) : (
                                    <label className="cursor fill p-2">
                                        <div className="button-ui p-11" onClick={product_file_Upload}><MdAddAPhoto className="icon cursor" />Upload</div>

                                        <input
                                            type="file" accept=".jpg,.jpeg,.png"
                                            style={{ display: "none" }}
                                            onChange={async (e) => {
                                                const selectedFile = e.target.files[0];
                                                if (selectedFile) {
                                                    setProduct_file(selectedFile);
                                                    setViewfile_url(URL.createObjectURL(selectedFile));

                                                }
                                            }}
                                        />
                                    </label>

                                )}
                            </div>
                        </div>

                        {isLoading ? (
                            <Lodinging />
                        ) : product_filedata.length === 0 ? (
                            <div>No categories found</div>
                        ) : (
                            product_filedata.map((row, index) => (
                                <div className="ui-items items-back border" key={index}>
                                    <img src={row.url || logo_default} className="logo_default" />
                                    <div className="border-top">
                                        <table>
                                            <tr>
                                                <td className="text-h4 text-off"  >Size</td>
                                                <td className="text-h4 text-off">Type</td>
                                                <td className="text-h4 text-off">Delete</td>
                                            </tr>
                                            <tr>
                                                <td className="text-h4"  >{row.size || 0}</td>
                                                <td className="text-h4">{row.type || ""}</td>


                                            </tr>
                                        </table>
                                        <div className="text-h5">Create:
                                            {row.date_time?.toDate
                                                ? row.date_time.toDate().toLocaleString("en-IN", {
                                                    day: "2-digit",
                                                    month: "short",
                                                    year: "numeric",
                                                    hour: "2-digit",
                                                    minute: "2-digit",
                                                })
                                                : "No data"}
                                        </div>
                                        <table>
                                            <tr>
                                                <td >
                                                    <div onClick={() => Save_Set_thumbnail(row.url)}

                                                        className="cursor bold green text-h4 p-1">Set Thumbnail</div>
                                                </td>
                                                <td >
                                                    <div onClick={() => {
                                                        deleteFileByUid(row.uid);

                                                    }} className="cursor bold red text-h4 p-1"> Delete</div>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                    <br />
  {/* explanation */}
                    <div>
                        <div className="text-h1 bold">Explanation upto 5 videos</div>
                        <div className="ui-grid-150">
                            <div className="ui-items items-back  border rounded"  >
                                <img src={explanationfile_url || banner_default} className="banner_default_view" />
                                <div className="border-top flex center">
                                    {explanation_file !== null ? (
                                        <Lodingingimg />
                                    ) : (
                                        <label className="cursor fill p-2">
                                            <div className="button-ui p-11" ><MdAddAPhoto className="icon cursor" /> Upload</div>

                                            <input
                                                type="file" accept=".mp4,.mov"
                                                style={{ display: "none" }}
                                                onChange={async (e) => {
                                                    const selectedFile = e.target.files[0];
                                                    if (selectedFile) {
                                                        setExplanation_file(selectedFile);
                                                        setExplanationfile_url(URL.createObjectURL(selectedFile));

                                                    }
                                                }}
                                            />
                                        </label>

                                    )}
                                </div>
                            </div>

                            {isLoading ? (
                                <Lodinging />
                            ) : explanation_filedata.length === 0 ? (
                                <div>No file found</div>
                            ) : (
                                explanation_filedata.map((row, index) => (
                                    <div className="ui-items items-back border" key={index}>
                                        <img src={row.url || banner_default} className="banner_default_view" />
                                        <div className="border-top">
                                            <table>
                                                <tr>
                                                    <td className="text-h4 text-off"  >Size</td>
                                                    <td className="text-h4 text-off">Type</td>
                                                    <td className="text-h4 text-off">Delete</td>
                                                </tr>
                                                <tr>
                                                    <td className="text-h4"  >{row.size || 0}</td>
                                                    <td className="text-h4">{row.type || ""}</td>


                                                </tr>
                                            </table>
                                            <div className="text-h5">Create:
                                                {row.date_time?.toDate
                                                    ? row.date_time.toDate().toLocaleString("en-IN", {
                                                        day: "2-digit",
                                                        month: "short",
                                                        year: "numeric",
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                    })
                                                    : "No data"}
                                            </div>
                                            <table>
                                                <tr>

                                                    <td >
                                                        <div onClick={() => {
                                                            deleteFileByUid(row.uid);

                                                        }} className="cursor bold red text-h4 p-1"> Delete</div>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                ))
                            )}
                        </div>
                    </div>
                    {/* From the manufacturer */}
                    <div>
                        <div className="text-h1 bold">From the manufacturer banner  2</div>
                        <div className="ui-grid-150">
                            <div className="ui-items items-back  border rounded"  >
                                <img src={viewManufacturerfile_url || banner_default} className="banner_default_view" />
                                <div className="border-top flex center">
                                    {manufacturer_file !== null ? (
                                        <Lodingingimg />
                                    ) : (
                                        <label className="cursor fill p-2">
                                            <div className="button-ui p-11" onClick={manufacturer_file_Upload}><MdAddAPhoto className="icon cursor" /> Upload</div>

                                            <input
                                                type="file" accept=".jpg,.jpeg,.png"
                                                style={{ display: "none" }}
                                                onChange={async (e) => {
                                                    const selectedFile = e.target.files[0];
                                                    if (selectedFile) {
                                                        setManufacturer_file(selectedFile);
                                                        setViewManufacturerfile_url(URL.createObjectURL(selectedFile));

                                                    }
                                                }}
                                            />
                                        </label>

                                    )}
                                </div>
                            </div>

                            {isLoading ? (
                                <Lodinging />
                            ) : manufacturer_filedata.length === 0 ? (
                                <div>No file found</div>
                            ) : (
                                manufacturer_filedata.map((row, index) => (
                                    <div className="ui-items items-back border" key={index}>
                                        <img src={row.url || banner_default} className="banner_default_view" />
                                        <div className="border-top">
                                            <table>
                                                <tr>
                                                    <td className="text-h4 text-off"  >Size</td>
                                                    <td className="text-h4 text-off">Type</td>
                                                    <td className="text-h4 text-off">Delete</td>
                                                </tr>
                                                <tr>
                                                    <td className="text-h4"  >{row.size || 0}</td>
                                                    <td className="text-h4">{row.type || ""}</td>


                                                </tr>
                                            </table>
                                            <div className="text-h5">Create:
                                                {row.date_time?.toDate
                                                    ? row.date_time.toDate().toLocaleString("en-IN", {
                                                        day: "2-digit",
                                                        month: "short",
                                                        year: "numeric",
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                    })
                                                    : "No data"}
                                            </div>
                                            <table>
                                                <tr>

                                                    <td >
                                                        <div onClick={() => {
                                                            deleteFileByUid(row.uid);

                                                        }} className="cursor bold red text-h4 p-1"> Delete</div>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                ))
                            )}
                        </div>
                    </div>
                    <br />
                    {/* Review slideshow 5 */}
                    <div>
                        <div className="text-h1 bold">Review slideshow 5</div>
                        <div className="ui-grid-150">
                            <div className="ui-items items-back  border rounded"  >
                                <img src={viewreviewslideshowfile_url || banner_default} className="banner_default_view" />
                                <div className="border-top flex center">
                                    {reviewslideshow_file !== null ? (
                                        <Lodingingimg />
                                    ) : (
                                        <label className="cursor fill p-2">
                                            <div className="button-ui p-11"
                                                onClick={manufacturer_file_Upload}><MdAddAPhoto className="icon cursor" /> Upload</div>

                                            <input
                                                type="file" accept=".jpg,.jpeg,.png"
                                                style={{ display: "none" }}
                                                onChange={async (e) => {
                                                    const selectedFile = e.target.files[0];
                                                    if (selectedFile) {
                                                        setReviewslideshow_file(selectedFile);
                                                        setViewreviewslideshowfile_url(URL.createObjectURL(selectedFile));

                                                    }
                                                }}
                                            />
                                        </label>

                                    )}
                                </div>
                            </div>
                            {/* review_slideshow_filedata */}
                            {isLoading ? (
                                <Lodinging />
                            ) : review_slideshow_filedata.length === 0 ? (
                                <div>No file found</div>
                            ) : (
                                review_slideshow_filedata.map((row, index) => (
                                    <div className="ui-items items-back border" key={index}>
                                        <img src={row.url || banner_default} className="banner_default_view" />
                                        <div className="border-top">
                                            <table>
                                                <tr>
                                                    <td className="text-h4 text-off"  >Size</td>
                                                    <td className="text-h4 text-off">Type</td>
                                                    <td className="text-h4 text-off">Delete</td>
                                                </tr>
                                                <tr>
                                                    <td className="text-h4"  >{row.size || 0}</td>
                                                    <td className="text-h4">{row.type || ""}</td>


                                                </tr>
                                            </table>
                                            <div className="text-h5">Create:
                                                {row.date_time?.toDate
                                                    ? row.date_time.toDate().toLocaleString("en-IN", {
                                                        day: "2-digit",
                                                        month: "short",
                                                        year: "numeric",
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                    })
                                                    : "No data"}
                                            </div>
                                            <table>
                                                <tr>

                                                    <td >
                                                        <div onClick={() => {
                                                            deleteFileByUid(row.uid);

                                                        }} className="cursor bold red text-h4 p-1"> Delete</div>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                ))
                            )}
                        </div>
                    </div>
                    <br />
                    {/* PPT Photos */}
                    <div>
                        <div className="text-h1 bold">PPT Photos 20</div>
                        <div className="ui-grid-150">
                            <div className="ui-items items-back  border rounded"  >
                                <img src={pptphotoshowfile_url || banner_default} className="banner_default_view" />
                                <div className="border-top flex center">
                                    {pptphotoshowf_file !== null ? (
                                        <Lodingingimg />
                                    ) : (
                                        <label className="cursor fill p-2">
                                            <div className="button-ui p-11" onClick={manufacturer_file_Upload}><MdAddAPhoto className="icon cursor" /> Upload</div>

                                            <input
                                                type="file" accept=".jpg,.jpeg,.png"
                                                style={{ display: "none" }}
                                                onChange={async (e) => {
                                                    const selectedFile = e.target.files[0];
                                                    if (selectedFile) {
                                                        setPptphotoshowf_file(selectedFile);
                                                        setPPTPhotoshowfile_url(URL.createObjectURL(selectedFile));

                                                    }
                                                }}
                                            />
                                        </label>

                                    )}
                                </div>
                            </div>

                            {isLoading ? (
                                <Lodinging />
                            ) : pptphotoshowf_file_filedata.length === 0 ? (
                                <div>No file found</div>
                            ) : (
                                pptphotoshowf_file_filedata.map((row, index) => (
                                    <div className="ui-items items-back border" key={index}>
                                        <img src={row.url || banner_default} className="banner_default_view" />
                                        <div className="border-top">
                                            <table>
                                                <tr>
                                                    <td className="text-h4 text-off"  >Size</td>
                                                    <td className="text-h4 text-off">Type</td>
                                                    <td className="text-h4 text-off">Delete</td>
                                                </tr>
                                                <tr>
                                                    <td className="text-h4"  >{row.size || 0}</td>
                                                    <td className="text-h4">{row.type || ""}</td>


                                                </tr>
                                            </table>
                                            <div className="text-h5">Create:
                                                {row.date_time?.toDate
                                                    ? row.date_time.toDate().toLocaleString("en-IN", {
                                                        day: "2-digit",
                                                        month: "short",
                                                        year: "numeric",
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                    })
                                                    : "No data"}
                                            </div>
                                            <table>
                                                <tr>

                                                    <td >
                                                        <div onClick={() => {
                                                            deleteFileByUid(row.uid);

                                                        }} className="cursor bold red text-h4 p-1"> Delete</div>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                ))
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>


    );
}
